import { LineStyle, Outline, Shadow, Theme } from "./types";

export const CSS_VALUE_AND_UNIT_REGEX = /^0$|^(?<value>[0-9]+(\.[0-9]+)?)(?<unit>[a-zA-Z]+|%)$/;

const DEFAULT_OUTLINE: Outline = {
  enabled: false,
  color: '#000000',
  width: '5px'
};

const DEFAULT_SHADOW: Shadow = {
  enabled: false
};

const DEFAULT_LINE: LineStyle = {
  align: 'center',
  bold: false,
  color: '#FFFFFF',
  italic: false,
  outline: DEFAULT_OUTLINE,
  shadow: DEFAULT_SHADOW
};

export const defaultTheme: Theme = {
  id: 'DEFAULT',
  name: 'Default Theme',
  background: '#000000',
  verticalAlignment: 'middle',
  fadeToBlackTime: 1,
  font: {
    face: 'Arial',
    size: 40,
    normal: DEFAULT_LINE,
    minor: {
      ...DEFAULT_LINE,
      color: '#FFFF00'
    },
    lineHeight: 1.2,
    letterSpacing: 0
  },
  margin: {
    top: '1rem',
    bottom: '1rem',
    left: '1rem',
    right: '1rem'
  },
  meta: {
    font: {
      face: 'Arial',
      size: 18,
      ...DEFAULT_LINE,
      align: 'right'
    },
    duration: 10
  },
  textBox: {
    enabled: false,
    backgroundColor: '',
    borderColor: '#FFFFFF',
    borderWidth: '3px',
    padding: '1rem'
  },
  scripture: {
    showAnnotations: true
  }
};
